import AyudaUsuario from '@/views/ayuda/AyudaUsuario.vue';
import AyudaMedico from '@/views/ayuda/AyudaMedico.vue';
import AyudaPersona from '@/views/ayuda/AyudaPersona.vue';
import AyudaCita from '@/views/ayuda/AyudaCita.vue';
import AyudaAtencion from '@/views/ayuda/AyudaAtencion.vue';
import AyudaInterconsulta from '@/views/ayuda/AyudaInterconsulta.vue';
import AyudaReferencia from '@/views/ayuda/AyudaReferencia.vue';
import AyudaAviso from '@/views/ayuda/AyudaAviso.vue';
import AyudaEmpresaForm from '@/views/ayuda/AyudaEmpresaForm.vue';
import AyudaEspeEmpr from '@/views/ayuda/AyudaEspeEmpr.vue';
import AyudaElemEmpr from '@/views/ayuda/AyudaElemEmpr.vue';
import AyudaAtencionReportes from '@/views/ayuda/AyudaElemEmpr.vue';

import MainLayout from '@/components/MainLayout.vue';

const guides = [
  {
    title: "Configuración de Usuarios",
    description: "Configura los perfiles de usuarios para controlar el acceso y las funcionalidades disponibles en el sistema.",
    link: "/guias/AyudaUsuario",
    component: AyudaUsuario
  },
  {
    title: "Registro de Médicos",
    description: "Administra el registro de médicos, incluyendo información personal y detalles profesionales.",
    link: "/guias/AyudaMedico",
    component: AyudaMedico
  },
  {
    title: "Gestión de Pacientes",
    description: "Administra la información de los pacientes, incluyendo historial médico y citas programadas.",
    link: "/guias/AyudaPersona",
    component: AyudaPersona
  },
  {
    title: "Registro de Citas",
    description: "Gestiona el proceso de registro de citas médicas, permitiendo programar y reprogramar citas según necesidad.",
    link: "/guias/AyudaCita",
    component: AyudaCita
  },
  {
    title: "Registro de Atenciones",
    description: "Detalla el proceso de registro de atenciones médicas, desde la llegada del paciente hasta su salida, incluyendo diagnósticos y tratamientos.",
    link: "/guias/AyudaAtencion",
    component: AyudaAtencion
  },
  {
    title: "Registro de Interconsultas",
    description: "Facilita el proceso de registro de interconsultas médicas, permitiendo la colaboración entre diferentes especialistas.",
    link: "/guias/AyudaInterconsulta",
    component: AyudaInterconsulta
  },
  {
    title: "Registro de Referencias/Derivaciones",
    description: "Permite registrar y gestionar las referencias y derivaciones de pacientes a otros especialistas o centros médicos.",
    link: "/guias/AyudaReferencia",
    component: AyudaReferencia
  },
  {
    title: "Registro de Avisos",
    description: "Administra el registro de avisos importantes dentro del sistema, asegurando que la información relevante sea comunicada eficientemente.",
    link: "/guias/AyudaAviso",
    component: AyudaAviso
  },
  {
    title: "Datos de la Empresa",
    description: "Gestiona la información relevante de la empresa o centro médico, incluyendo datos fiscales y configuraciones generales.",
    link: "/guias/AyudaEmpresaForm",
    component: AyudaEmpresaForm
  },
  {
    title: "Especialidades",
    description: "Administra las diferentes especialidades médicas disponibles en el centro, permitiendo asignar médicos y servicios adecuados.",
    link: "/guias/AyudaEspeEmpr",
    component: AyudaEspeEmpr
  },
  {
    title: "Elementos y Tarifario",
    description: "Gestiona los elementos y tarifarios de los servicios médicos, incluyendo precios y descripciones de procedimientos y tratamientos.",
    link: "/guias/AyudaElemEmpr",
    component: AyudaElemEmpr
  },
  {
    title: "Reportes Médicos",
    description: "Genera reportes médicos detallados para seguimiento de pacientes, estadísticas y análisis de datos médicos.",
    link: "/guias/AyudaAtencionReportes",
    component: AyudaAtencionReportes
  }
];

function generateGuideRoutes(guides) {
  return guides.map(guide => ({
    path: guide.link,
    name: guide.title,
    component: MainLayout,
    props: { defaultComponent: guide.component }
  }));
}

const guideRoutes = generateGuideRoutes(guides);

export { guides, guideRoutes };
